import React, { Component } from 'react';
import { translate } from 'react-i18next';

import './Download.css';

declare var CONFIGURATIONS;

class Download extends Component {

  render() {
    const { t, data } = this.props;
    const downloadItems = [];
    data.forEach((f, index) => {
      const links = [];
      f.resources.forEach((r, index2) => {
        links.push(<li key={`downloadLink${index}${index2}`}><a href={r.url} target='_blank' rel='noopener noreferrer'>{r.format}</a></li>);
      });

      downloadItems.push(
        <div key={`downloadItem${index}`}>
          <p className='downloadItemTitle'>{f.title}</p>
          <ul>
            {links}
          </ul>
        </div>
      );
    });

    return (
      <React.Fragment>
        <div className='downloadListLinks'>
          <p dangerouslySetInnerHTML={{ __html: t('download.one_by_one') }} />
          <div className='listContainer'>
            {downloadItems}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default translate()(Download);
